import React from 'react'
import About from './About'
import FAQContactSection from '../LandingPagecomponents/FAQContactSection'
import Navbar from '../common/Navbar'
import Footer from '../common/Footer'

export default function AboutPage() {
  return (
      <div>
        <Navbar/>
          <About />
          <FAQContactSection/>
          <Footer/>
    </div>
  )
}
